// extracted by mini-css-extract-plugin
export default {"header":"styles_header__0fY+o","headerTitle":"styles_headerTitle__658+8","crossbusston":"styles_crossbusston__BfUeP"};